import React, { Component } from 'react';
import { Redirect } from "react-router-dom";

import { stopTimer, addToCart, getObjects, AuthenticatedUser} from '../api';
import queryString from "query-string";

import SelectSearch from 'react-select-search';
import './tSearchStyles.css';

import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'

import moment from 'moment';
                       
class Tournaments extends Component {
    constructor(props) {
        super(props);
        const { user } = AuthenticatedUser();
        const value=queryString.parse(this.props.location.search);

        this.state = {
            loading: true, // set to false once loading is completed
            data: [],
            user: user,
            mode: value.mode
        };
    }

    addToCart = (itemId, quantity) => {        
        addToCart(itemId, quantity, () => {
            this.props.onHeaderDataChanged();
        });
    }

    loadTournamentPages = () => {
        this.setState({ loading: true});
        getObjects('tournamentPage').then(d2 => {
            if (d2 && d2.error) {
                console.log(d2.error);
            } else {
                this.setState({ data: d2.tournamentPages, loading: false});
            }
        });
    };

    componentDidMount() {
        window.scrollTo(0, 0);  
        this.loadTournamentPages();
    }

    render(){
        if (this.state.loading) { return null; }
        stopTimer();    
        const {mode, data} = this.state;
        const futureTournaments = data.filter(x=>x.status === 'publish' && moment().isBefore(x.endDate))

        const params = queryString.parse(this.props.location.search);
        if (!this.state.user.isLoggedIn && params.mode) return <Redirect to={`/pages/login?mode=${params.mode}`} />  

        return (
            <div className="container" style={{marginTop: "24px", marginBottom: "24px"}}>   
                {futureTournaments.length > 0 
                ? <>
                {mode === 'compete' && <p style={{backgroundColor: "#b48c50", color: "white", padding: "10px", marginTop: "25px", marginBottom: "50px"}}>Please review available tournaments and select one for competition.</p>}
                {mode === 'watch' && <p style={{backgroundColor: "#b48c50", color: "white", padding: "10px", marginTop: "25px", marginBottom: "50px"}}>Please review available tournaments and select one to observe.</p>}
                {mode === 'judge' && <p style={{backgroundColor: "#b48c50", color: "white", padding: "10px", marginTop: "25px", marginBottom: "50px"}}>Please review available tournaments and select one to judge.</p>}
                </>
                : <p style={{backgroundColor: "#b48c50", color: "white", padding: "10px", marginTop: "25px", marginBottom: "50px"}}>There are no upcoming tournaments scheduled at this time.  Check back soon.</p>
                }
                <div className="row form-group justify-content-start">
                    <label className="col-sm-4 col-form-label">Search by Tournament Name: </label>
                    <div className="col-xl-8">
                        <SelectSearch style={{width: '100%'}}
                            options={data && data.filter(x=>x.status === 'publish').map(tp => { return ({value: tp._id, name: tp.title })})}
                            search
                            placeholder="Select Tournament Name"
                            onChange={ (value) => {
                                this.props.history.push(`/pages/tournament/${value}`)
                            }
                        }
                        />
                    </div>
                </div>

                <FullCalendar
                    height='80vh'
                    plugins={[ dayGridPlugin ]}
                    initialView="dayGridMonth"
                    events={data && data.filter(x=>x.status === 'publish').map((tp, index) => {
                        return ({
                            id: tp._id,
                            title: tp.title,
                            start:  tp.startDate,
                            end:  tp.endDate,
                            url: `/pages/tournament/${tp._id}`
                        })
                    })}
                    
                />
                             
            </div>                                
        )
    }
}


export default Tournaments;